import Swal from 'sweetalert2'

let text = /[ A-Za-zäÄëËïÏöÖüÜáéíóúáéíóúÁÉÍÓÚÂÊÎÔÛâêîôûàèìòùÀÈÌÒÙ.-]+/;
let email = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}/
let rfc = /[0-9A-Za-z]+/;
let phone = /[0-9]*/;
let cp = /^(?:0[1-9]\d{3}|[1-4]\d{4}|5[0-2]\d{3})$/;


// Variables Login Form
let correoLogin = document.getElementById("emailLogin"), contrasenaLogin = document.getElementById("passwordLogin");

// Variables Recuperar Contraseña Form
let correoRecuperar = document.getElementById("emailRecuperar");

// Variables Signin Form
let nombreSignin = document.getElementById("nameSignin"), paternoSignin = document.getElementById("dadSignin"), maternoSignin = document.getElementById("momSignin"), estadoSignin = document.getElementById("stateSignin"), paisSignin = document.getElementById("countrySignin"), diaSignin = document.getElementById("daySignin"), mesSignin = document.getElementById("monthSignin"), anioSignin = document.getElementById("yearSignin"), generoSignin = document.getElementById("genreSignin"), rfcSignin = document.getElementById("rfcSignin"), homoSignin = document.getElementById("homoSignin"), correoSignin = document.getElementById("emailSignin"), contrasenaSignin = document.getElementById("passwordSignin"), terminosSignin = document.getElementById("terminos-registro"), avisoSignin = document.getElementById("aviso-registro");

// Variables Llamame Form
let callMeName = document.getElementById("llamameName"), callMePhone = document.getElementById("llamamePhone");

// Validación Lamame Form
export const validarLlamameForm = () =>  {
  return "" == callMeName.value ? (Swal.fire({
      title: "¡Vaya, al parecer algo va mal!",
      text: "Verifica que el campo Nombre Completo no esté vacío.",
      type: "warning",
      confirmButtonText: "Aceptar"
  }), !1) : text.exec(callMeName.value) ? "" == callMePhone.value ? (Swal.fire({
      title: "¡Vaya, al parecer algo va mal!",
      text: "Verifica que el campo Número telefónico no esté vacío.",
      type: "warning",
      confirmButtonText: "Aceptar"
  }), !1) : console.log(true) : (Swal.fire({
      title: "¡Verifica tu Nombre!",
      text: "La estructura de tu Nombre no es correcta.",
      type: "error",
      confirmButtonText: "Aceptar"
  }), !1)
}

// Validación Login Form
export const validarLoginForm = () => {
  return "" == correoLogin.value ? (Swal.fire({
    title: "¡Vaya, al parecer algo va mal!",
    text: "Verifica que el campo correo electrónico no esté vacío.",
    type: "warning",
    confirmButtonText: "Aceptar"
  }), !1) : email.exec(correoLogin.value) ? "" == contrasenaLogin.value ? (Swal.fire({
      title: "¡Vaya, al parecer algo va mal!",
      text: "Verifica que estés ingresando tu contraseña.",
      type: "warning",
      confirmButtonText: "Aceptar"
  }), !1) : console.log(true) : (Swal.fire({
      title: "¡Verifica tu correo electrónico!",
      text: "La estructura de tu correo electrónico no es correcta.",
      type: "error",
      confirmButtonText: "Aceptar"
  }), !1)
}

// Validación Recuperar Contraseña Form
export const validarRecuperarForm = () => {
    return "" == correoRecuperar.value ? (Swal.fire({
        title: "¡Vaya, al parecer algo va mal!",
        text: "Verifica que el campo correo electrónico no esté vacío.",
        type: "warning",
        confirmButtonText: "Aceptar"
    }), !1) : email.exec(correoRecuperar.value) ? console.log(true) : (Swal.fire({
        title: "¡Verifica tu correo electrónico!",
        text: "La estructura de tu correo electrónico no es correcta.",
        type: "error",
        confirmButtonText: "Aceptar"
    }), !1)
}

// Validación Signin Form
export const validarSigninForm = () =>  {
  return "" == nombreSignin.value ? (Swal.fire({
      title: "¡Vaya, al parecer algo va mal!",
      text: "Verifica que el campo Nombre no esté vacío.",
      type: "warning",
      confirmButtonText: "Aceptar"
  }), !1) : text.exec(nombreSignin.value) ? "" == paternoSignin.value ? (Swal.fire({
      title: "¡Vaya, al parecer algo va mal!",
      text: "Verifica que el campo Apellido Paterno no esté vacío.",
      type: "warning",
      confirmButtonText: "Aceptar"
  }), !1) : text.exec(paternoSignin.value) ? "" == maternoSignin.value ? (Swal.fire({
      title: "¡Vaya, al parecer algo va mal!",
      text: "Verifica que el campo Apellido Materno no esté vacío.",
      type: "warning",
      confirmButtonText: "Aceptar"
  }), !1) : text.exec(maternoSignin.value) ? "" == estadoSignin.value ? (Swal.fire({
      title: "¡Vaya, al parecer algo va mal!",
      text: "Verifica que el campo Estado Civil no esté vacío.",
      type: "warning",
      confirmButtonText: "Aceptar"
  }), !1) : "" == paisSignin.value ? (Swal.fire({
      title: "¡Vaya, al parecer algo va mal!",
      text: "Verifica que el campo Nacionalidad no esté vacío.",
      type: "warning",
      confirmButtonText: "Aceptar"
  }), !1) : "" == diaSignin.value ? (Swal.fire({
      title: "¡Vaya, al parecer algo va mal!",
      text: "Verifica que el campo Día de Nacimiento no esté vacío.",
      type: "warning",
      confirmButtonText: "Aceptar"
  }), !1) : "" == mesSignin.value ? (Swal.fire({
      title: "¡Vaya, al parecer algo va mal!",
      text: "Verifica que el campo Mes de Nacimiento no esté vacío.",
      type: "warning",
      confirmButtonText: "Aceptar"
  }), !1) : "" == anioSignin.value ? (Swal.fire({
      title: "¡Vaya, al parecer algo va mal!",
      text: "Verifica que el campo Año de Nacimiento no esté vacío.",
      type: "warning",
      confirmButtonText: "Aceptar"
  }), !1) : "" == generoSignin.value ? (Swal.fire({
      title: "¡Vaya, al parecer algo va mal!",
      text: "Verifica que el campo Género no esté vacío.",
      type: "warning",
      confirmButtonText: "Aceptar"
  }), !1) : "" == rfcSignin.value ? (Swal.fire({
      title: "¡Vaya, al parecer algo va mal!",
      text: "Verifica que el campo RFC no esté vacío.",
      type: "warning",
      confirmButtonText: "Aceptar"
  }), !1) : rfc.exec(paternoSignin.value) ? "" == homoSignin.value ? (Swal.fire({
      title: "¡Vaya, al parecer algo va mal!",
      text: "Verifica que el campo HOMOCLAVE no esté vacío.",
      type: "warning",
      confirmButtonText: "Aceptar"
  }), !1) : rfc.exec(paternoSignin.value) ? "" == correoSignin.value ? (Swal.fire({
      title: "¡Vaya, al parecer algo va mal!",
      text: "Verifica que el campo Correo no esté vacío.",
      type: "warning",
      confirmButtonText: "Aceptar"
  }), !1) : email.exec(correoSignin.value) ? "" == contrasenaSignin.value ? (Swal.fire({
      title: "¡Vaya, al parecer algo va mal!",
      text: "Verifica que el campo Contraseña no esté vacío.",
      type: "warning",
      confirmButtonText: "Aceptar"
  }), !1) : "" == terminosSignin.value ? (Swal.fire({
      title: "¡Términos y Condiciones!",
      text: "Verifica que hayas aceptado los Términos y Condiciones.",
      type: "warning",
      confirmButtonText: "Aceptar"
  }), !1) : "" == avisoSignin.value ? (Swal.fire({
      title: "¡Aviso de Privacidad!",
      text: "Verifica que hayas aceptado el Aviso de Privacidad.",
      type: "warning",
      confirmButtonText: "Aceptar"
  }), !1) : console.log(true) : (Swal.fire({
      title: "¡Verifica tus datos!",
      text: "La estructura de tu correo electrónico no es correcta.",
      type: "error",
      confirmButtonText: "Aceptar"
  }), !1) : (Swal.fire({
      title: "¡Verifica tus datos!",
      text: "Al parecer no estás ingresando tu HOMOCLAVE correctamente.",
      type: "error",
      confirmButtonText: "Aceptar"
  }), !1) : (Swal.fire({
      title: "¡Verifica tus datos!",
      text: "Al parecer no estás ingresando tu RFC correctamente.",
      type: "error",
      confirmButtonText: "Aceptar"
  }), !1) : (Swal.fire({
      title: "¡Verifica tus datos!",
      text: "Al parecer no estás ingresando tu Apellido Materno correctamente.",
      type: "error",
      confirmButtonText: "Aceptar"
  }), !1) : (Swal.fire({
      title: "¡Verifica tus datos!",
      text: "Al parecer no estás ingresando tu Apellido Paterno correctamente.",
      type: "error",
      confirmButtonText: "Aceptar"
  }), !1) : (Swal.fire({
      title: "¡Verifica tus datos!",
      text: "Al parecer no estás ingresando tu Nombre correctamente.",
      type: "error",
      confirmButtonText: "Aceptar"
  }), !1)
}

// Validación Cotizador Auto Personas Hero
export const enviarSeguroCorreo = () => {
  return "" == coberturaCotizadorAutoH.value ? (Swal.fire({
      title: "¡Vaya, al parecer algo va mal!",
      text: "Verifica que el campo Cobertura no esté vacío.",
      type: "warning",
      confirmButtonText: "Aceptar"
  }), !1) : "" == pagoCotizadorAutoH.value ? (Swal.fire({
      title: "¡Vaya, al parecer algo va mal!",
      text: "Verifica que el campo Forma de Pago no esté vacío.",
      type: "warning",
      confirmButtonText: "Aceptar"
  }), !1) : console.log(true)
}

// Validación Cotizador Sindocatos Form
export const validarCotizadorSindicatos = () => {
  return "" == nombreCotizadorAuto.value ? (Swal.fire({
      title: "¡Vaya, al parecer algo va mal!",
      text: "Verifica que el campo Nombre no esté vacío.",
      type: "warning",
      confirmButtonText: "Aceptar"
  }), !1) : text.exec(nombreCotizadorAuto.value) ? "" == nombreCotizadorAutoSindicato.value ? (Swal.fire({
      title: "¡Vaya, al parecer algo va mal!",
      text: "Verifica que el campo Selecciona tu Sindicato no esté vacío.",
      type: "warning",
      confirmButtonText: "Aceptar"
  }), !1) : "" == correoCotizadorAuto.value ? (Swal.fire({
      title: "¡Vaya, al parecer algo va mal!",
      text: "Verifica que el campo Correo no esté vacío.",
      type: "warning",
      confirmButtonText: "Aceptar"
  }), !1) : email.exec(correoCotizadorAuto.value) ? "" == telefonoCotizadorAuto.value ? (Swal.fire({
      title: "¡Vaya, al parecer algo va mal!",
      text: "Verifica que el campo Número Telefónico no esté vacío.",
      type: "warning",
      confirmButtonText: "Aceptar"
  }), !1) : phone.exec(telefonoCotizadorAuto.value) ? "" == autoCotizadorAuto.value ? (Swal.fire({
      title: "¡Vaya, al parecer algo va mal!",
      text: "Verifica que el campo Tipo de Auto no esté vacío.",
      type: "warning",
      confirmButtonText: "Aceptar"
  }), !1) : "" == modeloCotizadorAuto.value ? (Swal.fire({
      title: "¡Vaya, al parecer algo va mal!",
      text: "Verifica que el campo Modelo del vehículo no esté vacío.",
      type: "warning",
      confirmButtonText: "Aceptar"
  }), !1) : "" == marcaCotizadorAuto.value ? (Swal.fire({
      title: "¡Vaya, al parecer algo va mal!",
      text: "Verifica que el campo Marca del vehículo no esté vacío.",
      type: "warning",
      confirmButtonText: "Aceptar"
  }), !1) : "" == subMarcaCotizadorAuto.value ? (Swal.fire({
      title: "¡Vaya, al parecer algo va mal!",
      text: "Verifica que el campo Sub marca del vehículo no esté vacío.",
      type: "warning",
      confirmButtonText: "Aceptar"
  }), !1) : "" == descripCotizadorAuto.value ? (Swal.fire({
      title: "¡Vaya, al parecer algo va mal!",
      text: "Verifica que el campo Descripción del vehículo no esté vacío.",
      type: "warning",
      confirmButtonText: "Aceptar"
  }), !1) : "" == cpCotizadorAuto.value ? (Swal.fire({
      title: "¡Vaya, al parecer algo va mal!",
      text: "Verifica que el campo C.P. no esté vacío.",
      type: "warning",
      confirmButtonText: "Aceptar"
  }), !1) : cp.exec(cpCotizadorAuto.value) ? "" == generoCotizadorAuto.value ? (Swal.fire({
      title: "¡Vaya, al parecer algo va mal!",
      text: "Verifica que el campo Género no esté vacío.",
      type: "warning",
      confirmButtonText: "Aceptar"
  }), !1) : "" == edadCotizadorAuto.value ? (Swal.fire({
      title: "¡Vaya, al parecer algo va mal!",
      text: "Verifica que el campo Edad no esté vacío.",
      type: "warning",
      confirmButtonText: "Aceptar"
  }), !1) : console.log(true) : (Swal.fire({
      title: "¡Verifica tu C.P.!",
      text: "La estructura de tu C.P. no es correcta.",
      type: "error",
      confirmButtonText: "Aceptar"
  }), !1) : (Swal.fire({
      title: "¡Verifica tu Número Telefónico!",
      text: "La estructura de tu Número Telefónico no es correcta.",
      type: "error",
      confirmButtonText: "Aceptar"
  }), !1) : (Swal.fire({
      title: "¡Verifica tu correo electrónico!",
      text: "La estructura de tu Correo electrónico no es correcta.",
      type: "error",
      confirmButtonText: "Aceptar"
  }), !1) : (Swal.fire({
      title: "¡Verifica tus datos!",
      text: "Al parecer no estás ingresando tu Nombre correctamente.",
      type: "error",
      confirmButtonText: "Aceptar"
  }), !1)
}
